export const authPriceValues = [ //금액
    {
        value: 1,
        name: '저가(L)'
    },{
        value: 2,
        name: '중가(M)'
    },{
        value: 3,
        name: '고가(H)'
    },
];

export const authBodyValues = (type) => {
    let women = [
        {
            imgName: 'InvertedTriangle',
            value: 64,
            name: '역삼각형 체형'
        },{
            imgName: 'Diamond',
            value: 65,
            name: '직사각형 체형'
        },{
            imgName: 'Circle',
            value: 66,
            name: '사각형 체형'
        },{
            imgName: 'Standard',
            value: 67,
            name: '원형 체형'
        },{
            imgName: 'TrickStandard',
            value: 68,
            name: '삼각형 체형'
        },{
            imgName: 'Triangle',
            value: 69,
            name: '모래시계형 체형'
        },{
            imgName: 'Rectangle',
            value: 70,
            name: '큰모래시계형 체형'
        },
    ]
    let men = [
        {
            imgName: 'InvertedTriangle',
            value: 1,
            name: '역삼각형 체형'
        },{
            imgName: 'Diamond',
            value: 2,
            name: '다이아몬드 체형'
        },{
            imgName: 'Circle',
            value: 3,
            name: '원형 체형'
        },{
            imgName: 'Standard',
            value: 4,
            name: '스탠다드 체형'
        },{
            imgName: 'TrickStandard',
            value: 5,
            name: '트릭스탠다드 체형'
        },{
            imgName: 'Triangle',
            value: 6,
            name: '삼각형 체형'
        },{
            imgName: 'Rectangle',
            value: 7,
            name: '직사각형 체형'
        },
    ]
    if(type == 1) {
        //여자
        return women
    }else if(type === '') {
        let arr = [].concat(men, women);
        return arr;
    }else{
        //남자
        return men
    }
}

export const authColorValues = [
    {
        name: 'red',
        value: 1
    },{
        name: 'yellow',
        value: 2
    },{
        name: 'green',
        value: 3
    },{
        name: 'blue',
        value: 4
    },{
        name: 'indigo',
        value: 5
    },{
        name: 'purple',
        value: 6
    },{
        name: 'brown',
        value: 7
    },{
        name: 'gray',
        value: 8
    },{
        name: 'white',
        value: 9
    },{
        name: 'black',
        value: 10
    },
];

export const authFaceValues = [
    {
        name: 'Round', //라운드형
        value: 3
    },{
        name: 'Oval', //계란형
        value: 1
    },{
        name: 'Oblong', //직사각형
        value: 6
    },{
        name: 'Square', //정사각형
        value: 4
    },{
        name: 'Triangle', //역삼각형
        value: 5
    },{
        name: 'Diamond', //다이아몬드형
        value: 2
    },
];

export const authSkinValues = [
    {
        name: '화이트톤', //가을
        value: 3,
        class: 'Fall'
    },{
        name: '피치톤', //봄
        value: 1,
        class: 'Spring'
    },{
        name: '옐로우톤', //겨울
        value: 4,
        class: 'Winter'
    },{
        name: '브라운톤', //여름
        value: 2,
        class: 'Summer'
    }
]

export const authJobValues = [
    {
        name: '사무직',
        value: 2
    },{
        name: '영업직',
        value: 3
    },{
        name: '자영업',
        value: 4
    },{
        name: '디자인',
        value: 5
    },{
        name: '개발자',
        value: 6
    },{
        name: '서비스직',
        value: 7
    },{
        name: '교육직',
        value: 8
    },{
        name: '예체능',
        value: 9
    },{
        name: '학생',
        value: 10
    },{
        name: '전문직',
        value: 11
    },{
        name: '무직',
        value: 12
    },{
        name: '기타',
        value: 1
    },
]

export const authMatValues = [
    {
        name: '옷이 크다',
        value: 1
    },{
        name: '잘 맞는다',
        value: 2
    },{
        name: '옷이 작다',
        value: 3
    },
];

export const returnMatValues = (type) => {
    if(type == 'mypage') {
        return [
            {
                name: '작다',
                value: 3
            },{
                name: '맞다',
                value: 2
            },{
                name: '크다',
                value: 1
            },
        ]
    }else{
        return [
            {
                name: '옷이 크다',
                value: 1
            },{
                name: '잘 맞는다',
                value: 2
            },{
                name: '옷이 작다',
                value: 3
            },
        ]

    }
}

export const authMatGenderToggle = (gender) => {
    if(gender == 0) { //남자
        let returnArray = [
            {
                value: 'matShoulder',
                name: '어깨',
                sendValue: 'mb_mat_shoulder'
            },{
                value: 'matTop',
                name: '가슴',
                sendValue: 'mb_mat_top'
            },{
                value: 'matMiddle',
                name: '배',
                sendValue: 'mb_mat_middle'
            },{
                value: 'matBottom',
                name: '엉덩이',
                sendValue: 'mb_mat_bottom'
            }
        ]
        return returnArray;
    }else{ //여자
        let returnArray = [
            {
                value: 'matShoulder',
                name: '어깨',
                sendValue: 'mb_mat_shoulder'
            },{
                value: 'matWaist',
                name: '허리',
                sendValue: 'mb_mat_waist'
            },{
                value: 'matMiddle',
                name: '배',
                sendValue: 'mb_mat_middle'
            },{
                value: 'matThigh',
                name: '엉덩이',
                sendValue: 'mb_mat_thigh'
            }
        ]
        return returnArray;
    }
};

export const authSurveyData = (gender) => {
    let sendData = {};
    if(gender == 0) { //남자
        sendData = {
            mb_body: 0, //체형
            mb_shop_price: 0, //평균쇼핑금액
            mb_color: 0, //선호색상
            mb_face: 0, //얼굴형
            mb_skin: 0, //피부톤
            mb_job: 0, //직종
            mb_job_extra: '', //직종이 1인경우 입력값
            mb_mat_shoulder: 0, //착용감-어깨
            mb_mat_middle: 0, //착용감-배
            mb_mat_top: 0, //착용감-가슴 (남자만)
            mb_mat_bottom: 0, //착용감-힙 (남자만)
        }
    }else{ //여자
        sendData = {
            mb_body: 0, //체형
            mb_shop_price: 0, //평균쇼핑금액
            mb_color: 0, //선호색상
            mb_face: 0, //얼굴형
            mb_skin: 0, //피부톤
            mb_job: 0, //직종
            mb_job_extra: '', //직종이 1인경우 입력값
            mb_mat_shoulder: 0, //착용감-어깨
            mb_mat_middle: 0, //착용감-배
            // mb_mat_top: 0, //착용감-가슴 (남자만)
            // mb_mat_bottom: 0, //착용감-힙 (남자만)
            mb_mat_waist: 0, //착용감-허리 (여자만)
            mb_mat_thigh: 0, //착용감-허벅지 (여자만)
        }

    }
    return sendData;
}

export const matchSendData = {
    mb_id: 'id',
    mb_password : 'password',
    mb_name : 'name',
    mb_nick: 'nick',
    mb_sex: 'gender',
    mb_birth: null,
    mb_body: 'body', //체형
    mb_shop_price: 'price', //평균쇼핑금액
    mb_color: 'color', //선호색상
    mb_face: 'face', //얼굴형
    mb_skin: 'skin', //피부톤
    mb_job: 'job', //직종
    mb_job_extra: 'jobExtra', //직종이 1인경우 입력값
    mb_mat_shoulder: 'matShoulder', //착용감-어깨
    mb_mat_middle: 'matMiddle', //착용감-배
    mb_mat_top: 'matTop', //착용감-가슴 (남자만)
    mb_mat_bottom: 'matBottom', //착용감-힙 (남자만)
    mb_mat_waist: 'matWaist', //착용감-허리 (여자만)
    mb_mat_thigh: 'matThigh', //착용감-허벅지 (여자만)

}
